import styled from "styled-components";
import { useForm } from "react-hook-form";
import { ArrowDownIcon, CloseBlueIcon } from "../../../assets/icons/Icons";
import {
  ajustador,
  estatusSiniestro,
  experto,
} from "../../../constants/capturaSiniestro";
import { InputDatePicker, InputFile, InputSelect, InputText } from "../../form";
import { SeguimientoCard } from "./SeguimientoCard";
import { formatTime, transformDate } from "../../../helpers/date";
import SeguimientoForm from "./SeguimientoForm";

export const General = ({
  contract,
  sinester,
  remider,
  documentSinester,
  documentRemider,
  getAllRemiderByIdSinester,
  open,
  setOpen,
}) => {
  const onButton = () => {
    setOpen((prev) => !prev);
  };

  const getDocumentsRemider = (idRemider) => {
    const dataDocsRemider =
      documentRemider.length > 0
        ? documentRemider.filter((item) => item.recordatorio_id === idRemider)
        : [];
    return dataDocsRemider;
  };

  const getName = (name) => {
    const extension = name?.split(".").pop();
    const nameWithoutExtension = name?.slice(0, -4);
    const newName = nameWithoutExtension?.slice(0, 25);
    return name?.length < 30 ? name : newName + "... ." + extension;
  };

  const {
    register,
    control,
    formState: { errors },
  } = useForm({});

  return (
    <ModuleContainer open={open}>
      <Header
        onClick={() => {
          onButton()
        }}
      >
        <ModuleTitle>General</ModuleTitle>
        <ArrowDownIcon className="arrow-down" />
      </Header>
      <Content className="content">
        <Divider />
        <ModuleTitle
          style={{ color: "var(--primary-royal-blue)", marginBottom: "20px" }}
        >
          Información
        </ModuleTitle>
        <NumeroSiniestro>
          Número del Siniestro: #
          {sinester.length > 0
            ? String(sinester[0].siniestro_id).padStart(4, "0")
            : "0000"}
        </NumeroSiniestro>
        <form>
          <RowContainer>
            <InputDatePicker
              readOnly={true}
              label="Fecha de siniestro"
              value={sinester.length > 0 && transformDate(sinester[0].fecha)}
              control={control}
              name="fechaSiniestro"
              errorMessage={errors.fechaSiniestro?.type}
            />
            <InputDatePicker
              readOnly={true}
              label="Fecha de reporte/aviso"
              value={
                sinester.length > 0 && transformDate(sinester[0].fecha_emi)
              }
              control={control}
              name="fechaReporteAviso"
              errorMessage={errors.fechaReporteAviso?.type}
            />
            <InputText
              label="Consecutivo de cliente"
              name="consecutivoCliente"
              type="text"
              value={sinester.length > 0 && sinester[0].consecutivo_cliente}
              control={control}
              placeholder="Consecutivo"
              register={{ ...register("consecutivoCliente") }}
              errorMessage={errors.consecutivoCliente?.type}
              readOnly
            />
          </RowContainer>
          <InputText
            label="Causa del siniestro"
            name="causaSiniestro"
            type="text"
            value={sinester.length > 0 && sinester[0].causa}
            control={control}
            placeholder="Causa"
            register={{ ...register("causaSiniestro") }}
            errorMessage={errors.causaSiniestro?.type}
            multiline={true}
            readOnly
          />
          <GridContainer>
            <InputText
              label="Lugar de siniestro"
              name="lugarSiniestro"
              type="text"
              value={sinester.length > 0 && sinester[0].lugar}
              control={control}
              placeholder="Lugar"
              register={{ ...register("lugarSiniestro") }}
              errorMessage={errors.lugarSiniestro?.type}
              readOnly
            />
            <InputSelect
              label="Estatus del siniestro"
              name="estatusSiniestro"
              valueView={sinester.length > 0 && sinester[0].estatus_siniestro}
              options={estatusSiniestro}
              control={control}
              errorMessage={errors.estatusSiniestro?.type}
              placeholder="Estatus"
              readOnly
            />
            <InputSelect
              label="Experto"
              name="experto"
              valueView={sinester.length > 0 && sinester[0].expero}
              options={experto}
              control={control}
              errorMessage={errors.experto?.type}
              placeholder="Experto"
              readOnly
            />
            <InputSelect
              label="Ajustador"
              name="ajustador"
              valueView={sinester.length > 0 && sinester[0].ajustador}
              options={ajustador}
              control={control}
              errorMessage={errors.ajustador?.type}
              placeholder="Ajustador"
              readOnly
            />
            <div>
              <div>
                <InputFile
                  label="Anexos documentales"
                  placeholder="Documentales"
                />
              </div>
              <DocsContainer>
                {documentSinester.map((item, i) => (
                  <DocButton key={i}>
                    <CloseBlueIcon />
                    <a
                      href={item?.url}
                      target="_blank"
                      rel="noreferrer"
                      className="overflow-ellipsis"
                    >
                      {getName(item?.nombre_archivo)}
                    </a>
                  </DocButton>
                ))}
              </DocsContainer>
            </div>
          </GridContainer>
        </form>
        <ModuleTitle
          style={{
            color: "var(--primary-royal-blue)",
            marginBottom: "20px",
            marginTop: "32px"
          }}
        >
          Historial de Seguimiento
        </ModuleTitle>
        <Divider />
        {remider.length > 0 &&
          remider.map(({ nota, fecha, recordatorio_id }, index) => (
            <div key={index}>
              <SeguimientoCard
                date={formatTime(fecha)}
                note={nota}
                files={getDocumentsRemider(recordatorio_id)}
              />
            </div>
          ))}
        <SeguimientoForm
          contract={contract}
          sinester={sinester}
          getAllRemiderByIdSinester={getAllRemiderByIdSinester}
        />
      </Content>
    </ModuleContainer>
  )
};

const DocsContainer = styled.div`
  display: flex;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const DocButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid var(--secondary-maya-blue);
  background-color: var(--secondary-alice-blue);
  padding: 4px 14px 4px 4px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--primary-royal-blue);
  font-size: 12px;
  transition: 300ms;
  text-decoration: underline;
  font-weight: 600;
  max-width: 200px;
  & svg {
    width: 22px;
    height: 22px;
  }
  &:hover {
    opacity: 0.8;
  }
  .overflow-ellipsis {
    text-overflow: ellipsis;
  }
  p {
    width: 90px;
    white-space: nowrap;
    overflow: hidden;
  }
`;

const ModuleContainer = styled.div`
  background-color: #fff;
  border-radius: 24px;
  padding: 40px;
  width: 1200px;
  display: flex;
  flex-direction: column;
  box-shadow: 19px 70px 29px rgba(4, 3, 63, 0.01),
    11px 40px 25px rgba(4, 3, 63, 0.03), 5px 18px 18px rgba(4, 3, 63, 0.04),
    1px 4px 10px rgba(4, 3, 63, 0.05), 0px 0px 0px rgba(4, 3, 63, 0.05);
  transition: 300ms;
  margin-bottom: 30px;
  @media only screen and (max-width: 1280px) {
    width: 90vw;
    padding: 40px 20px;
  }
  //Divider
  & > .content {
    display: ${(props) => (props.open ? "block" : "none")};
  }
  & .arrow-down {
    transition: 500ms;
    transform: ${(props) => (props.open ? "rotate(180deg)" : "rotate(0deg)")};
  }
`;

const Header = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModuleTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
`;

const NumeroSiniestro = styled.p`
  color: var(--primary-royal-blue);
  font-size: 18px;
  font-weight: 700;
  background-color: var(--secondary-alice-blue);
  padding: 12px 20px;
  width: fit-content;
  border-radius: 12px;
  margin-bottom: 32px;
`;

const Content = styled.div``;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  margin: 24px 0;
  background-color: var(--primary-pistachio);
`;

//---- FORM ----//
const RowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 12px;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 8px;
  }
  @media only screen and (max-width: 425px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const GridContainer = styled.div`
  display: grid;
  justify-content: space-between;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 12px;
  column-gap: 32px;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 8px;
  }
  @media only screen and (max-width: 425px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
